(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["chill-scroll-top"] && !Shopify.designMode) return;
  try {
    (function () {
    const btn = document.getElementById('chill-scroll-top');
    if (!btn) return;

    const THRESHOLD = 400;

    function onScroll() {
      if (window.scrollY > THRESHOLD) {
        btn.classList.add('is-visible');
      } else {
        btn.classList.remove('is-visible');
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });

    btn.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["chill-support-chat"] && !Shopify.designMode) return;
  try {
    (function () {
    const root    = document.getElementById('chill-support');
    if (!root) return;
    const trigger = root.querySelector('.chill-support__trigger');
    const popover = root.querySelector('.chill-support__popover');

    function open() {
      root.classList.add('is-open');
      trigger.setAttribute('aria-expanded', 'true');
      popover.setAttribute('aria-hidden', 'false');
    }

    function close() {
      root.classList.remove('is-open');
      trigger.setAttribute('aria-expanded', 'false');
      popover.setAttribute('aria-hidden', 'true');
    }

    trigger.addEventListener('click', () => {
      root.classList.contains('is-open') ? close() : open();
    });

    // Close on outside click
    document.addEventListener('click', (e) => {
      if (!root.contains(e.target)) close();
    });

    // Close on ESC
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') close();
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
